module.exports = __webpack_public_path__ + "static/media/loyalty-icon.6599d7be.png";